import { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
export const CopyButton = ({ id, tooltip = 'Copy ID' }) => {
  const [successVisible, setSuccessVisible] = useState(false);

  const handleCopy = (e) => {
    e.preventDefault();
    const copiedId = document.getElementById(id).innerText;

    // Note: the navigator.clipboard method only works in secure browsers
    // @see: https://developer.mozilla.org/en-US/docs/Web/API/Clipboard
    // if there is ever a need to run stream admin in http, a workaround must be added
    // @see: https://stackoverflow.com/questions/51805395/navigator-clipboard-is-undefined
    navigator.clipboard.writeText(copiedId).then(() => {
      setSuccessVisible(true);
      setTimeout(() => setSuccessVisible(false), 3000); // Remove success message after 3 seconds
    });
  };

  return (
    <>
      <button
        id={`button-${id}`}
        className='form-fit'
        onClick={handleCopy}
        onMouseEnter={() => {
          setSuccessVisible(false);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleCopy(e);
          }
        }}
        data-tooltip-id={`tooltip-${id}`}
        data-tooltip-content={successVisible ? 'Copied to clipboard' : tooltip}
        aria-label={successVisible ? 'Copied to clipboard' : tooltip}
      >
        <i
          aria-hidden='true'
          className='fa-solid fa-copy'
        />
      </button>
      <Tooltip id={`tooltip-${id}`} place='left' />
    </>
  );
};

CopyButton.propTypes = {
  id: PropTypes.string,
  tooltip: PropTypes.string,
};
